import React from "react"

const WalletIcon = ({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 18 15.231"
      fill="currentColor"
      className={className}
    >
  <g id="wallet" transform="translate(-2 -4)">
    <path id="Path_10" data-name="Path 10" d="M20,13.187H18.615V5.969a.676.676,0,0,0-.692-.656H4.077a.676.676,0,0,0-.692.656v7.219H2V5.969A2.027,2.027,0,0,1,4.077,4H17.923A2.027,2.027,0,0,1,20,5.969Z" fill="gray"/>
    <path id="Path_11" data-name="Path 11" d="M20,10.019H18.615a.684.684,0,0,0-.692-.673H4.077a.684.684,0,0,0-.692.673H2A2.051,2.051,0,0,1,4.077,8H17.923A2.051,2.051,0,0,1,20,10.019Z" transform="translate(0 -1.425)" fill="gray"/>
    <path id="Path_12" data-name="Path 12" d="M20,14.006H18.615a.682.682,0,0,0-.692-.669H4.077a.682.682,0,0,0-.692.669H2A2.045,2.045,0,0,1,4.077,12H17.923A2.045,2.045,0,0,1,20,14.006Z" transform="translate(0 -2.85)" fill="gray"/>
    <path id="Path_13" data-name="Path 13" d="M13.15,17.267l-.146.3a2.237,2.237,0,0,1-2,1.267h0a2.235,2.235,0,0,1-2-1.267l-.146-.3a2.237,2.237,0,0,0-2-1.267H2v4.957a2.1,2.1,0,0,0,2.077,2.124H17.923A2.1,2.1,0,0,0,20,20.957V16H15.154A2.235,2.235,0,0,0,13.15,17.267Z" transform="translate(0 -3.85)" fill="gray"/>
  </g>
</svg>

)
export default WalletIcon
